import { ApiResult, HttpClient } from "../http.js";
import { PartnerInvitationDto } from "../types/partner-invitations.js";

export interface CreatePartnerInvitationPayload {
  partnerEmail: string;
  partnerName: string;
  permissions: string[];
  expiresAt: string;
  entityType?: string;
  entityId?: string;
  entityTitle?: string;
}

export interface UpdatePartnerInvitationPermissionsPayload {
  permissions: string[];
}

export interface AcceptPartnerInvitationPayload {
  token: string;
}

export interface ListPartnerInvitationsQuery {
  page?: number;
  pageSize?: number;
  search?: string;
  entityType?: string;
  entityId?: string;
  status?: string;
  partnerEmail?: string;
}

export class PartnerInvitationsApi {
  constructor(private readonly http: HttpClient) {}

  create(payload: CreatePartnerInvitationPayload): Promise<ApiResult<{ id: string; rawToken: string }>> {
    return this.http.post<{ id: string; rawToken: string }>("/api/partner-invitations", { body: payload });
  }

  get(id: string): Promise<ApiResult<PartnerInvitationDto>> {
    return this.http.get<PartnerInvitationDto>(`/api/partner-invitations/${encodeURIComponent(id)}`);
  }

  list(query: ListPartnerInvitationsQuery = {}): Promise<ApiResult<PartnerInvitationDto[]>> {
    return this.http.get<PartnerInvitationDto[]>("/api/partner-invitations", { query: { ...query } });
  }

  accept(id: string, payload: AcceptPartnerInvitationPayload): Promise<ApiResult<string>> {
    return this.http.post<string>(`/api/partner-invitations/${encodeURIComponent(id)}/accept`, { body: payload });
  }

  revoke(id: string): Promise<ApiResult<PartnerInvitationDto>> {
    return this.http.post<PartnerInvitationDto>(`/api/partner-invitations/${encodeURIComponent(id)}/revoke`);
  }

  updatePermissions(id: string, payload: UpdatePartnerInvitationPermissionsPayload): Promise<ApiResult<PartnerInvitationDto>> {
    return this.http.put<PartnerInvitationDto>(`/api/partner-invitations/${encodeURIComponent(id)}/permissions`, { body: payload });
  }
}
